export const getStaticNav = (t) => [
    { title: t.home, title_hi: 'मुख्य पृष्ठ', path: '/' },
    {
        title: t.about,
        title_hi: 'हमारे बारे में',
        path: '/#about',
        dropdown: [
            { title: 'About VSEZ', title_hi: 'वीएसईजेड के बारे में', path: '/about-vsez' },
            { title: 'About Vizag', title_hi: 'विजाग के बारे में', path: '/about-vizag' },
            { title: 'Location Map', title_hi: 'स्थान मानचित्र', path: '/location-map' },
            { title: 'Infrastructure', title_hi: 'आधारभूत संरचना', path: '/infrastructure' },
            { title: 'FAQ', title_hi: 'सामान्य प्रश्न', path: '/faqs' },
            { title: 'Feedback', title_hi: 'प्रतिक्रिया', path: '/feedback' }
        ]
    },
    {
        title: t.sez,
        title_hi: 'एसईजेड',
        path: '#',
        dropdown: [
            { title: 'SEZ Scheme', title_hi: 'एसईजेड योजना', path: '/sez-scheme' },
            { title: 'SEZ Online Instructions', title_hi: 'एसईजेड ऑनलाइन निर्देश', path: '/sez-online-instructions' },
            { title: 'SEZ UAC Meetings', title_hi: 'एसईजेड यूएसी बैठकें', path: '/sez-uac-meetings' },
            { title: 'VSEZ Units', title_hi: 'वीएसईजेड इकाइयां', path: '/vsez-units' },
            { title: 'Private SEZ', title_hi: 'निजी एसईजेड', path: '/private-sez' },
            { title: 'Private SEZ Units', title_hi: 'निजी एसईजेड इकाइयां', path: '/private-sez-units' },
            { title: 'TS - Manufacturing and Services', title_hi: 'टीजी - विनिर्माण और सेवाएं', path: '/ts-manufacturing' },
            { title: 'Statistical Data', title_hi: 'सांख्यिकीय डेटा', path: '/statistical-data' },
            { title: 'GOI Acts / Policies', title_hi: 'भारत सरकार के अधिनियम/नीतियाँ', path: '/goi-policies' },
            { title: 'GIS Location of SEZs', title_hi: 'एसईजेड का जीआईएस स्थान', path: '/sez-locations' }
        ]
    },
    {
        title: t.eou,
        title_hi: 'ईओयू',
        path: '#',
        dropdown: [
            { title: 'EOU Scheme', title_hi: 'ईओयू योजना', path: '/eou-scheme' },
            { title: 'EOU Units', title_hi: 'ईओयू इकाइयां', path: '/eou-units' },
            { title: 'EOU AC Meetings', title_hi: 'ईओयू एसी बैठकें', path: '/eou-ac-meetings' },
            { title: 'Statistical Data', title_hi: 'ईओयू सांख्यिकीय डेटा', path: '/eou-statistical-data' }
        ]
    },
    { title: t.admin, title_hi: 'प्रशासन', path: '/administration' },
    { title: 'Assets', title_hi: 'संपत्ति', path: '/assets' },
    {
        title: 'Software',
        title_hi: 'सॉफ्टवेयर',
        path: '#',
        dropdown: [
            { title: 'Software Infrastructure', title_hi: 'सॉफ्टवेयर इन्फ्रास्ट्रक्चर', path: '/software-infrastructure' },
            { title: 'IT SEZs in AP', title_hi: 'ए.पी. में आईटी एसईजेड', path: '/it-sezs-ap' }
        ]
    },
    {
        title: 'CST / DBK',
        title_hi: 'सीएसटी/डीबीके',
        path: '#',
        dropdown: [
            { title: 'CST Reimbursement Status', title_hi: 'सीएसटी पुनर्भुगतान स्थिति', path: '/cst-status' }
        ]
    },
    {
        title: t.rti,
        title_hi: 'आरटीआई',
        path: '#',
        dropdown: [
            { title: 'Reports', title_hi: 'रिपोर्टों', path: '/reports' },
            { title: 'Voluntary Disclosure', title_hi: 'स्वैच्छिक प्रकटीकरण', path: '/voluntary-disclosure' },
            { title: 'Officers Related to RTI Matters', title_hi: 'आरटीआई मामलों से संबंधित अधिकारी', path: '/rti-officers' },
            { title: 'Reports & Receipts', title_hi: 'रिपोर्ट और रसीदें', path: '/receipts-disposal' },
            { title: 'Quarterly Returns', title_hi: 'तिमाही विवरणियां', path: '/quarterly-returns' },
            { title: 'Grievances', title_hi: 'शिकायतें', path: '/grievances' },
            { title: 'Parliament Questions', title_hi: 'संसद के प्रश्न', path: '/parliament-questions' }
        ]
    },
    {
        title: t.info,
        title_hi: 'सूचना केंद्र',
        path: '#',
        dropdown: [
            { title: 'Nodal Officer', title_hi: 'नोडल अधिकारी', path: '/nodal-officers' },
            { title: 'Notifications', title_hi: 'सूचनाएं', path: '/notifications' },
            { title: 'Source of Land Details', title_hi: 'भूमि विवरण का स्रोत', path: '/source-of-land' },
            { title: 'Circulars', title_hi: 'परिपत्र', path: '/circulars' },
            { title: 'Download Forms', title_hi: 'फॉर्म डाउनलोड करें', path: '/downloads' },
            { title: 'Help Desk', title_hi: 'सहायता केंद्र', path: '/helpdesk' },
            { title: "What's New", title_hi: 'नया क्या है', path: '/whats-new' }
        ]
    },
    {
        title: t.news,
        title_hi: 'समाचार',
        path: '#',
        dropdown: [
            { title: 'News Clips', title_hi: 'नई क्लिप', path: '/news-clips' },
            { title: 'Photo Gallery', title_hi: 'फोटो गैलरी', path: '/photo-gallery' },
            { title: 'Press Releases', title_hi: 'प्रेस विज्ञप्ति', path: '/press-releases' },
            { title: 'World Environment Day', title_hi: 'विश्व पर्यावरण दिवस', path: '/environment-day' },
            { title: 'Videos', title_hi: 'वीडियो', path: '/videos' }
        ]
    },
    {
        title: t.tenders,
        title_hi: 'निविदा',
        path: '#',
        dropdown: [
            { title: 'Awarded Tenders', title_hi: 'निविदा सूचना', path: '/awarded-tenders' },
            { title: 'Tender Notice', title_hi: 'निविदा सूचना', path: '/tenders-notice' }
        ]
    },
    { title: 'Contact', title_hi: 'संपर्क करें', path: '/contact' }
];